// Named palettes that can be selected with REACT_APP_THEME_PRESET, so a gym can
// be reskinned with one variable instead of thirty. Anything a preset leaves out
// falls back to the default in theme.js, and an individual REACT_APP_THEME_*
// variable still wins over the preset.
//
// A preset may also set `mode` ('light' or 'dark'). A light preset must supply
// textPrimary, textMuted and border, because those feed Material UI's palette
// text and divider colours, which otherwise stay on the dark defaults.

// Sourced from onebjjfitness.com. Squarespace 7.1 publishes the site palette as
// HSL custom properties in its site.css:
//   --accent-hsl:      218.18, 37.29%, 23.14%  -> #253551  deep navy, the brand
//   --darkAccent-hsl:  330,     2.44%, 16.08%  -> #2a2829  warm near-black, text
//   --lightAccent-hsl: 60,      7.46%, 86.86%  -> #e0e0db  warm cream, sections
//   --white-hsl / --black-hsl                  -> #ffffff / #000000
// The surfaces, lines and tints below are steps along those same three hues
// rather than hand-picked colours, so the family holds together. Status and
// chart colours are darkened from the defaults to stay legible on a light ground.
const onebjj = {
  mode: 'light',
  colors: {
    primary: '#253551',
    primaryLight: '#3d5785',
    primaryDark: '#1a2538',
    onPrimary: '#ffffff',
    accent: '#e0e0db',

    surface: '#f8f8f7',
    surfaceRaised: '#ffffff',
    surfaceSunken: '#ecece9',
    surfaceAccent: '#f3f3f1',
    surfaceMuted: '#e0e0db',
    surfaceHover: '#ecece9',
    surfaceSelected: '#d5ddec',
    surfaceLight: '#e0e0db',
    surfaceInfo: '#253551',
    // The inverted header variant and the crop backdrop, which stay dark so they
    // still read as a break from the page.
    surfaceContrast: '#253551',
    surfaceInverse: '#2a2829',

    border: '#d0d0c8',
    borderMuted: '#ecece9',
    borderStrong: '#a5a597',

    textPrimary: '#2a2829',
    textMuted: '#737363',
    link: '#253551',

    danger: '#b3352b',
    dangerMuted: '#8f2d24',
    dangerStrong: '#b71c1c',
    dangerBright: '#e53935',
    success: '#2e7d32',
    successLight: '#43a047',

    chart: {
      one: '#3d5785',
      two: '#b0b0b0',
      three: '#3d5785',
      four: '#3d5785',
    },
  },
};

export const presets = {
  onebjj,
};

export default presets;
